export { Checkbox, CheckboxProps, checkboxClasses } from "@mui/material";

export const CheckboxSizes = ["small", "medium"] as const;
export type CheckboxSize = (typeof CheckboxSizes)[number];
